import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time',
};
